<template>
  <div class="forbidden-page">
    <span class="forbidden-code">403</span>
    <h1>Kein Zugriff</h1>
    <p>
      Du bist angemeldet, aber dein Konto hat keine Berechtigung für diesen Bereich.
      Falls das nicht stimmen sollte, wende dich an einen Administrator.
    </p>
    <button type="button" class="btn-back" @click="goHome">Zurück zur Startseite</button>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { isReader } from '@/services/auth'

const router = useRouter()

function goHome() {
  router.push(isReader() ? '/portal/dashboard' : '/expectations-framework')
}
</script>

<style scoped>
.forbidden-page {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  gap: 8px;
}

.forbidden-code {
  font-size: 48px;
  font-weight: 700;
  color: #4da6ff;
  letter-spacing: 1px;
}

.forbidden-page h1 {
  font-size: 22px;
  font-weight: 700;
  color: #003366;
  margin-bottom: 4px;
}

.forbidden-page p {
  max-width: 420px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.btn-back {
  background: #003366;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
}
.btn-back:hover {
  background: #004080;
}
</style>
